<template>
  <div>
    <b-card>
      <div>
        <b-row class="mb-1">
          <b-col class="text-right">
            <b-button @click="UpdateContract()" variant="primary" v-ripple.400="'rgba(255, 255, 255, 0.15)'">
              Update Kontrak
            </b-button>
          </b-col>
        </b-row>
        <b-table show-empty :current-page="0" :busy="loading" :per-page="filter.size" :fields="fields" :items="items" :responsive="true">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #empty="scope">
            <h4 class="text-center">{{ scope.emptyText }}</h4>
          </template>
          <template #cell(expiredContract)="data">
            <div>
              {{ FormatDate(data.item.expiredContract) }}
            </div>
          </template>
          <template #head(selected)="data">
            <div class="checkbox-table">
              <b-form-checkbox @change="SelectAll($event)" />
            </div>
          </template>
          <template #cell(selected)="data">
            <div>
              <b-form-checkbox v-model="data.item.selected" />
            </div>
          </template>
        </b-table>
        <div class="mt-2">
          <b-pagination v-model="filter.page" :total-rows="pagination.total" :per-page="filter.size">

          </b-pagination>
        </div>
      </div>
    </b-card>
    <PermanentEmployeeForm
      @formPayload="UpdateForm($event)"
      ref="permanentFormRef"
      :loading="isLoadingForm"
    />
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormInput,BFormGroup,BTable,BPagination,BOverlay,BSpinner,BFormCheckbox } from "bootstrap-vue";
import { GetContractEmployeeServices } from '../../services/employee-paid-leave.service';
import { successNotification, errorNotification } from "@/auth/utils";
import utility from '../../libs/utility';
import PermanentEmployeeForm from '../../components/PermanentEmployee/PermanentEmployeeForm'
export default {
  name: "PermanentEmployee",
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BaseTable,
    BFormGroup,
    BFormInput,
    BTable,
    BPagination,
    BOverlay,
    BSpinner,
    BFormCheckbox,
    PermanentEmployeeForm
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: [
        {
          key: "selected"
        },
        {
          key: "employeeName",
          label: "Nama"
        },
        {
          key: "gradeName",
          label: "Grade"
        },
        {
          key: "jobTitleName",
          label: "Job Title"
        },
        {
          key: "employeeStatusName",
          label: "Status"
        },
        {
          key: "expiredContract",
          label: "Tanggal Habis Kontrak"
        }
      ],
      formPayLoad: {
        statusEmployee: null
      },
      items: [],
      loading: false,
      isLoadingForm: false,
      pagination: {
        total: 0
      },
      filter: {
        title: "",
        page: 1,
        size: 10
      },
    }
  },
  methods: {
    FormatDate(date) {
      return utility.FormatDate(date);
    },
    SelectAll(event) {
      this.items.forEach((item) => {
        item.selected  =  event;
      });
    },
    UpdateContract() {
      this.$bvModal.show('permanent-employee');
    },
    UpdateForm(data) {
      window.console.log(data);
      let findSelected = this.items.filter((items) => {
        return true === items.selected;
      });
      if (findSelected.length < 1) {
        this.$bvModal.hide('permanent-employee');
        return errorNotification(this, "Oops!", "Pilih Pembaharuan Calon Karyawan Tetap");
      }
      this.isLoadingForm  =  true;
      let req = {
        employeeIds: [],
        employeeStatusId: data.statusEmployee.value.paramListId,
        salaryStructureId: data.structureSalary.value.salaryStructureId,
        workPeriod: parseInt(data.workingYears)
      };
      findSelected.forEach((itemsFind) => {
        req.employeeIds.push(itemsFind.employeeId);
      });
      this.$http.put('/employee/status', req)
        .then((result) => {
          window.console.log(result);
          if (result.data.code === "00") {
            successNotification(this,result.data.message);
            this.$refs.permanentFormRef.ClosePopup();
            this.GetEmployeePermanent();
          } else {
            errorNotification(this, "Oops!", result.data.message);
          }
          this.isLoadingForm  =  false;
        })
        .catch((e) => {
          this.isLoadingForm  =  false;
          errorNotification(this, "Oops!", e.message);
        });

    },
    async GetEmployeePermanent() {
      this.loading = true;
      let req = {
        page: this.filter.page,
        size: this.filter.size
      };
      this.items  = [];
      await GetContractEmployeeServices.find(req)
        .then((result) => {
          window.console.log(result);
          if (result.code === "00") {
            result.data.content.forEach((items) => {
              items['selected'] = false;
              this.items.push(items);
            });
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          return errorNotification(this, "Oops!", e.message);
        })
    }
  },
  mounted() {
    this.GetEmployeePermanent();
  }
}
</script>
